import en from './en.json';
import de from './de.json';

export const defaultLocale = 'en';

export const languages = {
  en,
  de,
};
